import { useEffect, useState } from 'react';

export const useIsOpenAnimationDone = (durationMs: number): boolean => {
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setIsDone(true), durationMs);

    return () => clearTimeout(timeoutId);
  }, [durationMs]);

  return isDone;
};
